export default "__VITE_ASSET__BAaqXagC__"